import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication, provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import Aura from '@openng/optimus-ui-themes/aura';
import { definePreset } from '@openng/optimus-ui-styled';
import { ConfirmationService, MessageService } from '@openng/optimus-ui/api';
import { provideOptimus } from '@openng/optimus-ui/config';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { ConfirmPopupModule } from '@openng/optimus-ui/confirmpopup';
import { ToastModule } from '@openng/optimus-ui/toast';
// import { CoreModule } from './app/@core/core.module';
import { ThemeModule } from './app/@theme/theme.module';
import { AppComponent } from './app/app.component';
import { routes as AppRoutes } from './app/app.routes';
import { TextDirective } from './app/shared/directives/text.directive';
import { HttpExchangeInterceptor } from './app/shared/services/http-exchange.interceptor';
import { environment } from './environments/environment';

(window as any).global = window;

if (environment.production) {
  enableProdMode();
}

// This is a temporary solution to pass the query parameters to the quiz app.
// This will be removed when the quiz app is integrated with the main app.
if (window.location.hostname.startsWith('quiz.') || window.location.hostname === 'localhost') {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  let authToken = urlParams.get('authToken');
  const roles = urlParams.get('roles');
  const profile = urlParams.get('profile');
  const hostname = urlParams.get('hostname');

  if (lang) {
    localStorage.setItem('lang', lang);
  }
  if (authToken) {
    authToken = authToken.replace(/ /g, '+');
    localStorage.setItem('authToken', authToken);
  }
  if (roles) {
    localStorage.setItem('roles', roles);
  }
  if (profile) {
    localStorage.setItem('profile', profile);
  }
  if (hostname) {
    localStorage.setItem('hostname', hostname);
  }
}

// Configure PrimeNG Aura theme with light mode
const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideRouter(AppRoutes, withComponentInputBinding()), provideClientHydration(withNoIncrementalHydration()),
    importProvidersFrom(BrowserModule, ConfirmPopupModule, ConfirmDialogModule,
      ThemeModule.forRoot(),
      BrowserModule, FormsModule, ToastModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpExchangeInterceptor,
      multi: true,
    },
    TextDirective,
    ConfirmationService,
    MessageService,
    provideAnimations(),
    provideOptimus({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: 'system',
          cssLayer: false
        }
      }
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ]
})
  .catch(err => console.error(err));
